import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=165b492e&scoped=true&"
import script from "./divider.vue?vue&type=script&lang=js&"
export * from "./divider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b492e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165b492e')) {
      api.createRecord('165b492e', component.options)
    } else {
      api.reload('165b492e', component.options)
    }
    module.hot.accept("./divider.vue?vue&type=template&id=165b492e&scoped=true&", function () {
      api.rerender('165b492e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/divider.vue"
export default component.exports